import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import { Tag } from "antd";
import moment from "moment";
import SmallProfileCard from "../../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../../constants/common";

const OnBench = () => {
    const config: MasterConfigs = {
        api: () => `/users?isOnBench=${true}`,
        modalTitle: () => 'On Bench',
        getColumns: () => [
            {
                title: "Employee",
                align: 'left',
                width: 200,
                ellipsis: true,
                render: (_, record) => <SmallProfileCard
                    name={constants.GET_FULL_NAME(record)}
                    avatar={record?.avatar}
                    subTitle={record?.employeeId}
                />
            },
            // {
            //     title: 'Employee Id',
            //     dataIndex: 'employeeId',
            //     key: 'employeeId',
            //     isSearch: true,
            //     align: 'center',
            //     width: 120,
            //     fixed: 'left',
            //     render: (text) => text,
            // },
            // {
            //     title: 'First Name',
            //     dataIndex: 'firstName',
            //     key: 'firstName',
            //     width: 120,
            //     fixed: 'left',
            //     isSearch: true,
            // },
            // {
            //     title: 'Last Name',
            //     dataIndex: 'lastName',
            //     key: 'lastName',
            //     width: 120,
            //     fixed: 'left',
            //     isSearch: true,
            // },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'workEmail',
                width: 200,
                ellipsis: true,
                isSearch: true,
            },
            {
                title: 'Gender',
                dataIndex: 'gender',
                key: 'gender',
                align: 'center',
                width: 100,
                isSearch: true,
            },
            {
                title: 'Designation',
                dataIndex: 'role',
                key: 'role',
                width: 150,
                render: (item) => {
                    if (item) {
                        return item.name;
                    }
                },
            },
            {
                title: 'On Bench',
                dataIndex: '',
                key: '',
                align: 'center',
                width: 150,
                render: (text, record) => {
                    let days = moment().diff(moment(record?.dateOfJoining), 'days')
                    if (days > 30) {
                        return <Tag color="red">{days} days</Tag>;
                    } else {
                        return <Tag color="green">{days} days</Tag>;
                    }
                },
            },
            {
                title: 'Is On Notice Period',
                dataIndex: 'isOnNoticePeriod',
                key: 'isOnNoticePeriod',
                align: 'center',
                width: 150,
                render: (text) => text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>,
            },
            {
                title: 'Probation End Date',
                dataIndex: 'probationPolicy',
                key: 'probationPolicy',
                isSearch: true,
                width: 150,
                align: 'center',
                render: (text, record) => {
                    if (record.probationEndDate) {
                        return moment(record.probationEndDate).format('DD MMM, YYYY');
                    } else {
                        if (text?.probationPeriod) {
                            return moment(record.dateOfJoining).add(text.probationPeriod, text.periodType.toLowerCase()).format('DD MMM, YYYY');
                        }
                    }
                },
            },
            {
                title: 'Account Status',
                dataIndex: 'isBlock',
                key: 'isBlock',
                align: 'center',
                width: 150,
                render: (text) => {
                    return !text ? <Tag color="green">{'Active'}</Tag> : <Tag color="red">Blocked</Tag>;
                }
            },
            {
                title: 'Joining Date',
                dataIndex: 'dateOfJoining',
                key: 'dateOfJoining',
                isSearch: true,
                width: 150,
                align: 'center',
                render: (text) => moment(text).format('DD MMM, YYYY'),
            },
        ],
        getFormColumns: () => [],
    }
    return (
        <MasterComponent config={config} />
    );
}

export default OnBench;